<template>
  <div class="page" :class="citySite==''?'VR':''"  v-wechat-title="$route.meta.title">
    <img class="vr-bj" src="../../assets/vr.jpg" alt="" v-if="citySite==''">

    <!--新增全景视频模块-->
    <div class="video-vr border-box" v-if="root.length>0">
      <div class="video-vr-con" v-for="(item,index) in root">
        <div class="video-vr-top" @click="goVideoVR(item.id)">
          <span class="video-vr-mask"></span>
          <img class="icon_360" src="../../assets/icon_360.png" alt="" v-if="citySite!=1&&citySite!=''">
          <div class="video-vr-img" id="video-vr-img" v-if="citySite==''&&index==0"></div>
          <img class="video-vr-img" v-lazy="item.tvideourl" alt="" v-else>
          <img class="video-vr-btn pause" src="../../assets/view-video-bf.png" alt="" v-if="citySite!=''">
          <div class="video-tit border-box hide" v-if="citySite!=''">{{item.name}}</div>
          <span class="video-vr-txt num" v-if="citySite!=''">{{item.listencount|initNumber}}次播放</span>
          <span class="video-vr-txt spot" v-if="citySite!=1&&citySite!=''">{{item.spotNum}}个讲解点</span>
        </div>
        <div class="video-vr-bot border-box">
          <img class="fl video-vr-guide" v-lazy="item.headimg" alt="" v-if="citySite!=''">
          <span class="fl video-vr-name hide" v-if="citySite!=''">{{item.fname}}</span>
          <span class="fl video-vr-tag" v-if="citySite==''&&index==0">推荐</span>
          <span class="fl video-vr-tag" v-if="citySite==''&&index==1">热门</span>
          <span class="fl video-vr-name hide" v-if="citySite==''">{{item.name}}</span>
          <button class="fr btn buy-btn" @click="goVideoVR(item.id)" v-if="item.isbuy>0 || item.price<=0">{{citySite==''?'去观看':'观看'}}</button>
          <button class="fr btn buy-btn" @click="buyVideoVr(item.id)" v-else>{{citySite==''?'去体验':'购买'}}</button>
        </div>
      </div>
    </div>
    <p class="load-tip" ref="loadtip">{{loadText}}</p>

  </div>

</template>

<script>

  import {getViewDetail, getBagTab, getCatalogue, uploadScan, getEnvelope, getUserTui, uploadUserBrowse, getNotice,getViewVr,citySiteVR,siteVrlist } from "@/service/getData";
  import {wxGetPosition,getCityInfo,wxShareme,listenEndOrder, listenTurl, creatOrder, pushOrder} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'

  import PhotoSphereViewer from 'photo-sphere-viewer'
  import 'photo-sphere-viewer/dist/photo-sphere-viewer.css'

  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        siteid: this.$route.query.siteid || '',//站点id
        sregion: this.$route.query.sregion || '',//省站点id:430000
        shopid: this.$route.query.shopid || '', //景区id
        spotid: this.$route.query.spotid || '', //景点id
        userInfo: {}, //用户信息
        page: 1,
        rows: 7,
        loadText: "数据加载中",
        latlng: {lat: '', lng: ''}, //经纬度信息
        cityInfo: { citycode: this.$route.query.citycode||"1", city: "全部", address: "" },
        citySite: this.$route.query.citySite || '',//是否为城市站点首页跳过来 1：是  3,语音包跳过来的
        TimeStamp: new Date().getTime(),  //获取当前时间
        appKey: '',
        appKeyA: '',
        citycode: this.$route.query.citycode || '',//城市站点code或者home页面的citycode
        root:[],//VR视频列表
        total: '',//VR视频专辑总数
        order: this.$route.query.order || 0, //0 距离  1 最新
      }
    },
    computed: {

    },
    created(){

      this.$loading.show('数据加载中');
      this.userInfo = getStore("userInfo");
      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      if(this.appKey){
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey":this.appKey});
      }else{
        setStore("appKey", {"appKey":""});
      }

      let self = this;
      let cityInfo = getStore("cityInfo");
      if (cityInfo == null || cityInfo.citycode == null || cityInfo.citycode == "") {
        getCityInfo(function (res) {
          self.latlng = res;
          self.cityInfo = { citycode: "1", city: "全国", address: "" };
          setStore("cityInfo",self.cityInfo);
          self.initData(self.page);
        });
      } else {
        this.cityInfo = getStore("cityInfo");
        wxGetPosition(function (res) {
          self.latlng = {lat: res.latitude, lng: res.longitude};
          self.initData(self.page);
        });
      }

      window.addEventListener("scroll",this.handleFun)
    },
    beforeDestroy(){
      window.removeEventListener("scroll",this.handleFun);
      if (this.PSV) {
        this.PSV.destroy()
      }
    },
    methods: {

      //获取语音+景区+推荐信息
      async initData(page){
        let res;
        if(this.citySite == 2){
          this.$route.meta.title = ' ';
          res = await citySiteVR({
            TimeStamp: this.TimeStamp,
            openid: this.userInfo.openid,
            citySite:this.citySite,
            type:1,
            code:this.citycode,
            page: page,
            rows: this.rows
          });
        }else if(this.citySite == 1){
          this.$route.meta.title = '视频列表';
          res = await citySiteVR({
            TimeStamp: this.TimeStamp,
            openid: this.userInfo.openid,
            citySite:this.citySite,
            type:0,
            code:this.citycode,
            page: page,
            rows: this.rows
          });
        }else if(this.citySite == 3){
          this.$route.meta.title = '视频列表';
          res = await siteVrlist({
            TimeStamp: this.TimeStamp,
            openid: this.userInfo.openid,
            id: this.shopid,
            page: page,
            rows: this.rows
          });
        }else{
          this.$route.meta.title = 'VR真人讲解';
          res = await getViewVr({
            TimeStamp: this.TimeStamp,
            openid: this.userInfo.openid,
            shopid: this.shopid,
            spotid: this.spotid || '',
            code: this.citycode || '1',
            lat: this.latlng.lat || '',
            lng: this.latlng.lng || '',
            siteid: this.siteid,
            sregion: this.sregion,
            page: page,
            rows: this.rows,
            order: this.order
          });
        }

        if (res.errcode === '00000'){
          this.$loading.hide();
          this.total = res.data.total
          let root = res.data.root
          if (page >= Math.ceil(this.total / this.rows)) {
            this.loadText = '已经到底了'
          } else {
            this.loadText = '加载更多'
          }
          if (root.length > 0) {
            this.root = [...this.root, ...root];
          } else {
            if (page == 1) {
              this.root = [];
              this.loadText = '暂无数据'
            } else {
              this.loadText = '已经到底了'
            }
          }

          let title = this.userInfo.name + '@你：';
          let desc = '我正在“金牌解说”，一起来听景区故事吧';
          let link = "";
          if(this.citySite && this.citySite != ""){
            link = '/video-vrlist?citycode='+ this.citycode +'&citySite='+ this.citySite +'&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey);
          }else {
            link = '/video-vrlist?shopid='+ this.shopid +'&spotid='+ this.spotid +'&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey);
          }
          wxShareme(title,desc,"",link);

        }else {
          this.$toast(res.errmsg)
        }
      },

      handleFun: function (){
        let self = this;
        self.$nextTick(function() {
          loadMore(self,function(page){
            self.initData(page);
          });
        })
      },

      //点击购买，调用下订单公用方法
      buyVideoVr(id){
        let self = this;
        setStore("source", {"source": "video"});
        setStore("couponid", {"couponid": ""});

        if(this.citySite == 1){
          self.$router.push({
            path: `/pay?${'pid='+id+'&cid=&shopid=&bagtype=1'+'&appKey='+(self.appKey)}`
          });
        }else if(this.citySite == 2){
          self.$router.push({
            path: `/pay?${'pid='+id+'&cid=&shopid=&bagtype=2'+'&appKey='+(self.appKey)}`
          });
        }else{
          self.$router.push({
            path: `/pay?${'pid='+id+'&cid=&shopid='+self.shopid+'&bagtype=2'+'&appKey='+(self.appKey)}`
          });
        }
      },

      //跳转到VR视频
      goVideoVR(id){
        if(this.citySite == 1){
          this.$router.push({
            path: `/video-play1?${'id='+id+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey+'&bagtype=1'}`
          });
        }else if(this.citySite == 2){
          this.$router.push({
            path: `/video-vr?${'id='+id+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey+'&bagtype=2'}`
          });
        }else{
          this.$router.push({
            path: `/video-vr?${'id='+id+'&shopid='+this.shopid+'&spotid='+this.spotid+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey+'&bagtype=2'}`
          });
        }
      },

      showPhotoVR(imgurl,obj){
//            var imgurl = require('../../assets/qj.jpg');
        var self = this;
        this.PSV = PhotoSphereViewer({
          container: obj,
          panorama: imgurl,
          autoload: true, //自动播放
          time_anim: 2000, //默认2000
          anim_speed: '2rpm', //默认2rpm
          navbar: false,  //不显示下面的导航栏
          overload: function(){
            self.loadPSV = true;
          }
        });
      },

    },
    watch:  {
      root(){
        var self = this;
        this.$nextTick(function(){
          if(self.root[0].vrimg && self.root[0].vrimg != '' && self.root[0].vrimg != null && self.citySite==""){
            self.showPhotoVR(self.root[0].vrimg,'video-vr-img');
          }
        })
      },
    },
    components: {},
    //格式化数据
    filters: {
      initNumber: function (num) {
        if(num>10000){
          num = (num/10000).toFixed(2)+'万'
        }else if(num>1000){
          num = (num/1000).toFixed(2)+'千'
        }
        return num;
      }
    }
  }

</script>

<style scoped>
  @import "../../style/alert.css";
  @import "../../style/voice.css";

  .page{ padding-bottom: .2rem; }

  /*全景视频*/
  .video-vr{padding: 0 .26rem .4rem;}
  .video-vr-con{ padding-top: .24rem; width: 100%;height: 3.98rem;border-radius: .1rem;box-shadow: 0 0 .25rem #f7f7f7;overflow: hidden;}
  .video-vr-tit{width:100%;height: .96rem;font: bold .28rem/1.03rem "Microsoft YaHei";color: #3d3d3d;overflow: hidden;}
  .video-vr-tit .fr{font:normal .24rem/1.03rem "Microsoft YaHei";color: #555;}
  .video-vr-top{ display: block; position:relative;width: 100%;height: 3rem;border-radius: .1rem .1rem 0 0;overflow: hidden;}
  .video-vr-img{position:absolute;top:0;left:0;width: 100%;height: 100%;border-radius: .1rem .1rem 0 0;object-fit: cover;}
  .video-vr-mask{position: absolute;z-index: 1;top:0;left: 0;width: 100%;height: 100%;background: rgba(0,0,0,.3);}
  .video-vr .icon_360{position: absolute;z-index: 1;top:.12rem;right:.12rem;width: 1.36rem;height: auto;}
  .video-vr .video-tit{position: relative;z-index: 1;width:100%;height:.75rem;padding: 0 1.6rem 0 .2rem;font: .26rem/.75rem "Microsoft YaHei";color: #fff;}
  .video-vr-btn{position: absolute;z-index:1;top:50%;left:50%;width: 1.02rem;height: auto;-webkit-transform: translate(-50%,-50%);transform: translate(-50%,-50%);}
  .video-vr-txt{position: absolute;z-index: 1;bottom: .14rem;font: bold .2rem "Microsoft YaHei";color: #fff;}
  .video-vr-txt.num{ left:.2rem;}
  .video-vr-txt.spot{ right:.2rem;}
  .video-vr-bot{position:relative;width:100%;height: .98rem;padding: 0 .2rem;}
  .video-vr-guide{width: .58rem;height: .58rem;margin-top:.2rem;border-radius: 50%;object-fit: cover;}
  .video-vr-name{max-width:70%;margin-left: .15rem;font: .26rem/.98rem "Microsoft YaHei";color: #000;}
  .video-vr-bot .buy-btn{top: 50%;transform: translateY(-50%);}

  /*2020.12.29 新样式*/
  .page.VR{ position: relative; background-color: #18171d; }
  .page.VR .vr-bj{ position: relative; width: 100%; height: auto; }
  .page.VR .video-vr{ padding: 0 .3rem .4rem; margin-top: -1.04rem; }
  .page.VR .video-vr-con{ height: auto; border-radius: .2rem;box-shadow: none; }
  .page.VR .video-vr-top{ height: 3.6rem;border-radius: .2rem .2rem 0 0; }
  .page.VR .video-vr-img{border-radius: .2rem .2rem 0 0; overflow: hidden; }
  .page.VR .video-vr-mask{ background: rgba(0,0,0,.2); }

  .page.VR .video-vr-bot{height: 1.2rem; padding: 0 .3rem; background: url(../../assets/vr-2.png) no-repeat center; background-size: 100% 100%;}
  .page.VR .video-vr-name{ font-size: .32rem; line-height: .94rem; color: #fff; }
  .page.VR .video-vr-tag{ margin-top: .3rem; width: .68rem; height: .32rem; font-size: .2rem; line-height: .3rem; color: #fff; text-align: center; background: url(../../assets/vr-1.png) no-repeat center; background-size: 100% 100%; }
  .page.VR .buy-btn{ padding: 0; right: .24rem; top: .3rem;transform: translateY(0); width: 1.4rem; height: .56rem;line-height: .54rem;font-size: .28rem; color: #262626; letter-spacing: .02rem;box-shadow:inset 0 .15rem .15rem -.15rem #000;background: #fcc729; }
</style>
<style>
  .page.VR .psv-container{ position: absolute; padding: 1px; left:-1px; top:-1px; right:-1px; bottom:-1px; }
</style>



// WEBPACK FOOTER //
// src/page/video-vrlist/video-vrlist.vue